import { CorePage } from '@ecosystem/newron-core';
import React from 'react';
import { useNavigate } from 'react-router';
import { APP_VERSION, BFF_HOST } from '../../lib/constants';
import { mapCoreMetaParams } from '../../lib/analytics/tools';
import { ContextName } from '../types';
import { Proposition, ROUTE_PREFIX } from '../../utils/constants';
import { getUpsellContext } from '../../root';

function DPOverviewPage() {
  const navigate = useNavigate();
  const defaultSubsection = 'Overview';
  const calcTrackingParams = (_eventName, meta) => {
    return mapCoreMetaParams(Proposition.DistributionPanel, meta, defaultSubsection, defaultSubsection);
  };
  const { Dpo, Dp } = ROUTE_PREFIX;

  return (
    <CorePage
      context={{
        name: ContextName.dp,
        url: `${BFF_HOST}/context/${Dp}/overview`,
        excludeFilters: false,
        excludePriceFilter: false,
      }}
      page={{
        name: 'dp-overview',
        url: `${BFF_HOST}/${Dpo}/page`,
        appVersion: APP_VERSION,
      }}
      data={{
        url: `${BFF_HOST}/${Dpo}/data`,
      }}
      collection={{
        url: `${BFF_HOST}/context/collection/overview?proposition=${Dp}`,
      }}
      navigate={navigate}
      defaultSubsection={defaultSubsection}
      calcTrackingParams={calcTrackingParams}
      upsellContext={getUpsellContext()}
    />
  );
}

export { DPOverviewPage };
export default DPOverviewPage;
